import BaseTextDivider from './TextDivider';

export const TextDivider = BaseTextDivider;
export type { TextDividerProps } from './TextDivider.interface';
